<app-rounded-hover-box [border]="true" (click)="customize.emit()">
  <app-theme-item
    [theme]="theme()"
    [gallery]="gallery()"
    [customTitle]="customTheme()?.name || (customTheme() === null ? undefined : 'Loading...')"
  ></app-theme-item>
</app-rounded-hover-box>
